import { SortOrder } from 'src/app/_enums/general/sort-order.enum';
import { OrderProcessingStatus } from 'src/app/_entities/orders/processing-statuses/order-processing-status';
import { ProcessingStatus } from '../../../_entities/orders/processing-statuses/processing-status';

export type StatusTabs = 'Open' | 'Picked' | 'Packed' | 'PartiallyShipped' | 'Shipped' | 'All';
export class OrdersFiltersModel {
  storeIds?: number[] = [];
  warehouseIds?: number[] = [];
  dateRange?: DateRange = new DateRange();
  searchTerm? = '';
  selectedStatusTab: StatusTabs = 'Open';
  orderStatuses?: OrderProcessingStatus[] = [ProcessingStatus.Open];
  sortBy?: OrderSortBy = OrderSortBy.Order_Date;
  sortOrder?: SortOrder = SortOrder.Desc;
  selected?: IIdMap = {};
  timestamp?: Date;
  customer?: string;
  tagOptions?: string[] = [];
  selectedTags?: string[] = [];
  selectedCarrierIds?: string[] = [];
  carrierOptions?: string[] = [];
}

export enum OrderSortBy {
  Store,
  Order_Date,
  Customer_Name,
  Total_Quantity,
  Status
}

export class DateRange {
  fromDate: Date;
  toDate: Date;

  constructor(from: Date = new Date(new Date().setDate(new Date().getDate() - 29)), to: Date = new Date()) {
    this.fromDate = new Date(from.setUTCHours(0, 0, 0, 0));
    this.toDate = new Date(to.setUTCHours(23, 59, 59, 0));
  }
}

export interface IIdMap {
  [key: number]: boolean;
}

